export const cssQueries = `
; Test basic rule set capture
(rule_set) @symbol.css_class.def
`;